
import { useState, useRef, useEffect, useCallback, useMemo } from "react";
import ShowimagesLoading from "../showImagesLoading";
import { elakay_API } from "../../../config";
import { createPortal } from "react-dom"; 
import GraffitiPreview, { DesignsList, DesignPreviewModal, useDesignsList, parseLoadedDesign, OutputView} from "./externPageGraffiti/GraffitiPreview";
import DesignStudio,{makeSlotDesign,  buildSavePayload, useDesignSave, SaveStatusBar, ImagePickerModal, SlotManager, } from "./externPageGraffiti/DesignStudio";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["sellerDashboard"]?.[key] || fallback;

/* ══════════════════════════════════════════════════════

   CSS GLOBAL
══════════════════════════════════════════════════════ */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500;600;700&family=Space+Mono:wght@400;700&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --n0:#f2f6fd;--n1:#ffffff;--n2:#f4f8fc;--n3:#eef6fb;--n4:#daeaf5;--n5:#c8ddea;
  --gold:#007399;--gold2:#00a4d8;--golda:rgba(0,115,153,.10);
  --teal:#4facfe;--teal2:#00f2fe;--teala:rgba(79,172,254,.10);
  --emerald:#34c759;--emeralda:rgba(52,199,89,.10);
  --white:#0d2d3d;--muted:#5a7a8a;--muted2:#8aa6b5;
  --ok:#34c759;--err:#ef4444;
  --b:rgba(0,115,153,.10);--b2:rgba(0,115,153,.18);
  --r:10px;--rL:18px;--tr:.18s ease;
  --ffd:'Bebas Neue',sans-serif;--ffb:'DM Sans',sans-serif;--ffm:'Space Mono',monospace;
}
html,body{font-family:var(--ffb);background:var(--n0);color:var(--white);min-height:100vh}
.sd-root{min-height:100vh;display:flex;flex-direction:column;background:var(--n0)}
.sd-topbar{display:flex;align-items:center;justify-content:space-between;padding:0 28px;height:56px;background:var(--n1);border-bottom:1px solid var(--b2);position:sticky;top:0;z-index:100;box-shadow:0 2px 24px rgba(0,0,0,.4);flex-shrink:0}
.sd-brand{display:flex;align-items:center;gap:10px}
.sd-logo{font-family:var(--ffd);font-size:22px;letter-spacing:3px;background:linear-gradient(135deg,var(--gold),var(--gold2));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.sd-logo-tag{font-size:10px;color:var(--muted);letter-spacing:2px;text-transform:uppercase;padding-left:10px;border-left:1px solid var(--b2)}
.sd-topbar-right{display:flex;align-items:center;gap:10px}
.sd-steps{display:flex;align-items:center;gap:0;background:var(--n2);border:1px solid var(--b);border-radius:var(--rL);overflow:hidden}
.sd-step{display:flex;align-items:center;gap:8px;padding:8px 18px;cursor:pointer;transition:all var(--tr);border-right:1px solid var(--b);font-size:11px;font-weight:600;color:var(--muted)}
.sd-step:last-child{border-right:none}
.sd-step:hover:not(.sd-step--active){background:var(--b);color:var(--white)}
.sd-step--active{background:var(--golda);color:var(--gold)}
.sd-step--done{color:var(--ok)}
.sd-step-num{width:20px;height:20px;border-radius:50%;border:1.5px solid currentColor;display:flex;align-items:center;justify-content:center;font-family:var(--ffm);font-size:8px;font-weight:700;flex-shrink:0}
.sd-step--active .sd-step-num{background:var(--gold);border-color:var(--gold);color:#fff}
.sd-step--done .sd-step-num{background:var(--ok);border-color:var(--ok);color:#fff}
.sd-main{flex:1;padding:28px;max-width:1200px;width:100%;margin:0 auto}
.sd-sec-head{margin-bottom:20px}
.sd-sec-title{font-family:var(--ffd);font-size:28px;letter-spacing:2px;color:var(--white);margin-bottom:4px}
.sd-sec-sub{font-size:12px;color:var(--muted);line-height:1.5}
.sd-card{background:var(--n2);border:1px solid var(--b2);border-radius:var(--rL);overflow:hidden}
.sd-card-head{display:flex;align-items:center;gap:9px;padding:13px 18px;border-bottom:1px solid var(--b);background:linear-gradient(180deg,rgba(255,255,255,.03),transparent)}
.sd-card-icon{font-size:16px;flex-shrink:0}
.sd-card-title{font-size:13px;font-weight:700;color:var(--white);flex:1}
.sd-card-body{padding:16px 18px;display:flex;flex-direction:column;gap:12px}
.sd-slot-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:14px}
.sd-slot-card{background:var(--n3);border:1.5px solid var(--b2);border-radius:var(--r);overflow:hidden;position:relative;transition:all var(--tr);display:flex;flex-direction:column}
.sd-slot-card:hover{border-color:var(--teal);box-shadow:0 4px 20px rgba(0,180,216,.12)}
.sd-slot-card.add-card{border-style:dashed;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:8px;min-height:200px;cursor:pointer;color:var(--muted)}
.sd-slot-card.add-card:hover{border-color:var(--gold);color:var(--gold);background:var(--golda)}
.sd-slot-img-wrap{position:relative;aspect-ratio:3/4;overflow:hidden;background:var(--n4)}
.sd-slot-img{width:100%;height:100%;object-fit:cover;display:block}
.sd-slot-img-placeholder{width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;color:var(--muted2)}
.sd-slot-badge{position:absolute;top:7px;left:7px;background:rgba(0,0,0,.75);border-radius:5px;font-size:8.5px;font-weight:700;color:#fff;padding:2px 7px}
.sd-slot-num{position:absolute;top:7px;right:7px;width:20px;height:20px;background:var(--gold);border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:var(--ffm);font-size:9px;font-weight:700;color:#fff}
.sd-slot-ctrl{padding:10px 12px;display:flex;flex-direction:column;gap:7px}
.sd-slot-label-input{background:var(--n4);border:1px solid var(--b2);border-radius:6px;color:var(--white);font-size:11.5px;font-weight:600;padding:5px 9px;width:100%;outline:none;font-family:var(--ffb)}
.sd-slot-label-input:focus{border-color:var(--gold)}
.sd-slot-actions{display:flex;gap:5px}
.sd-slot-btn{flex:1;padding:5px 0;border-radius:6px;border:1px solid var(--b2);background:var(--n4);color:var(--muted);font-size:9.5px;font-weight:600;cursor:pointer;font-family:var(--ffb);display:flex;align-items:center;justify-content:center;gap:4px}
.sd-slot-btn:hover{border-color:var(--teal);color:var(--teal)}
.sd-slot-btn.danger:hover{border-color:var(--err);color:var(--err)}
.sd-slot-btn.primary{border-color:var(--gold);color:var(--gold)}
.sd-url-row{display:flex;gap:6px;align-items:center}
.sd-url-input{flex:1;background:var(--n4);border:1px solid var(--b2);border-radius:6px;color:var(--white);font-size:10px;padding:5px 8px;outline:none;font-family:var(--ffm)}
.sd-field{display:flex;flex-direction:column;gap:4px}
.sd-lbl{font-size:9px;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.9px}
.sd-input,.sd-sel,.sd-ta{background:var(--n3);border:1px solid var(--b2);border-radius:7px;color:var(--white);font-family:var(--ffb);font-size:12px;padding:7px 10px;width:100%;outline:none}
.sd-input:focus,.sd-sel:focus,.sd-ta:focus{border-color:var(--gold);box-shadow:0 0 0 2px rgba(0,115,153,.12)}
.sd-ta{resize:vertical;min-height:64px}
.sd-sel{appearance:none;cursor:pointer;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='7' fill='%237a8499'%3E%3Cpath d='M5 7L0 0h10z'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 10px center;padding-right:28px}
.sd-r2{display:grid;grid-template-columns:1fr 1fr;gap:10px}
.sd-studio{display:grid;grid-template-columns:1fr 370px;gap:0;min-height:calc(100vh - 160px);background:var(--n1);border:1px solid var(--b2);border-radius:var(--rL);overflow:hidden}
.sd-studio-left{display:flex;flex-direction:column;border-right:1px solid var(--b);overflow:hidden}
.sd-studio-right{overflow-y:auto;background:var(--n2)}
.sd-face-tabs{display:flex;align-items:center;border-bottom:1px solid var(--b);background:var(--n2);overflow-x:auto;flex-shrink:0}
.sd-face-tab{padding:8px 14px;border:none;background:transparent;color:var(--muted);font-size:10.5px;font-weight:500;cursor:pointer;border-bottom:2px solid transparent;white-space:nowrap;font-family:var(--ffb);display:flex;align-items:center;gap:5px;flex-shrink:0}
.sd-face-tab.on{color:var(--teal);border-bottom-color:var(--teal);background:var(--teala)}
.sd-face-dot{width:5px;height:5px;border-radius:50%;background:var(--emerald)}
.sd-face-thumbs{display:flex;gap:4px;padding:4px 10px;margin-left:auto;border-left:1px solid var(--b)}
.sd-face-thumb{width:32px;height:32px;border-radius:4px;border:1.5px solid var(--b);background:var(--n3);cursor:pointer;overflow:hidden;display:flex;align-items:center;justify-content:center}
.sd-face-thumb.on{border:2px solid var(--gold)}
.sd-face-thumb img{width:100%;height:100%;object-fit:cover}
.sd-canvas-zone{flex:1;display:flex;flex-direction:column;overflow:hidden}
.sd-zbar{display:flex;align-items:center;gap:6px;padding:5px 10px;background:var(--n2);border-bottom:1px solid var(--b)}
.sd-zbtn{width:24px;height:24px;border-radius:5px;border:1px solid var(--b2);background:var(--n3);color:var(--white);cursor:pointer;display:flex;align-items:center;justify-content:center}
.sd-zbtn:hover:not(:disabled){background:var(--teal)}
.sd-zbtn:disabled{opacity:.35;cursor:not-allowed}
.sd-zpct{font-family:var(--ffm);font-size:10px;color:var(--teal);min-width:34px;text-align:center}
.sd-zreset{padding:2px 7px;border:1px solid var(--b2);background:transparent;color:var(--muted);border-radius:5px;font-size:9.5px;cursor:pointer;font-family:var(--ffb)}
.sd-stage{flex:1;overflow:hidden;background:var(--n0);position:relative}
.sd-canvas{display:block;width:100%;touch-action:none}
.sd-chint{font-size:9px;color:var(--muted2);text-align:center;padding:3px 0;background:var(--n2);border-top:1px solid var(--b)}
.sd-toggle-text,.sd-dl-btn{padding:3px 9px;border-radius:5px;font-size:9.5px;font-weight:700;cursor:pointer;font-family:var(--ffb);display:flex;align-items:center;gap:4px}
.sd-toggle-text{border:1px solid rgba(0,115,153,0.35);background:rgba(0,115,153,0.08);color:var(--gold)}
.sd-toggle-text.off{border-color:rgba(255,255,255,0.12);background:transparent;color:var(--muted)}
.sd-dl-btn{border:1px solid rgba(52,199,89,0.35);background:rgba(52,199,89,0.08);color:var(--emerald)}
.sd-panel{display:flex;flex-direction:column}
.sd-sec{padding:11px 13px;border-bottom:1px solid var(--b);display:flex;flex-direction:column;gap:9px}
.sd-stitle{font-family:var(--ffd);font-size:14px;letter-spacing:1.5px;color:var(--white);display:flex;align-items:center;gap:7px}
.sd-stitle::after{content:'';flex:1;height:1px;background:linear-gradient(90deg,var(--b2),transparent)}
.sd-field2{display:flex;flex-direction:column;gap:3px}
.sd-lbl2{font-size:9px;font-weight:600;color:var(--muted);text-transform:uppercase;letter-spacing:.9px}
.sd-input2,.sd-sel2,.sd-ta2{background:var(--n3);border:1px solid var(--b2);border-radius:7px;color:var(--white);font-family:var(--ffb);font-size:11.5px;padding:6px 9px;width:100%;outline:none}
.sd-input2:focus,.sd-ta2:focus{border-color:var(--gold)}
.sd-ta2{resize:vertical;min-height:58px}
.sd-cw{position:relative}
.sd-cw .sd-input2{padding-right:36px}
.sd-cc{position:absolute;right:7px;top:50%;transform:translateY(-50%);font-size:8.5px;color:var(--muted);pointer-events:none}
.sd-r2b{display:grid;grid-template-columns:1fr 1fr;gap:8px}
.sd-chips{display:flex;flex-wrap:wrap;gap:4px}
.sd-chip{padding:3px 9px;border-radius:14px;border:1px solid var(--b2);background:var(--n3);color:var(--muted);font-size:9.5px;font-weight:500;cursor:pointer;font-family:var(--ffb)}
.sd-chip:hover{border-color:var(--gold);color:var(--white)}
.sd-chip.on{border-color:var(--gold);background:var(--golda);color:var(--gold)}
.sd-chip-sm{padding:2px 6px;font-size:9px}
.sd-srow{display:flex;align-items:center;gap:7px}
.sd-slider{flex:1;accent-color:var(--gold);cursor:pointer;height:3px}
.sd-sval{font-family:var(--ffm);font-size:9.5px;color:var(--gold);min-width:32px;text-align:right}
.sd-presets{display:flex;flex-wrap:wrap;gap:3px;margin-top:3px}
.sd-qgrid{display:grid;grid-template-columns:repeat(3,30px);gap:3px}
.sd-qbtn{height:26px;border-radius:5px;font-size:11px;cursor:pointer;background:var(--n3);border:1px solid var(--b2);color:var(--muted);font-family:var(--ffb)}
.sd-qbtn:hover{background:var(--teala);border-color:var(--teal);color:var(--teal)}
.sd-colors{display:flex;flex-wrap:wrap;gap:4px;align-items:center}
.sd-sw{width:20px;height:20px;border-radius:50%;border:2px solid transparent;cursor:pointer}
.sd-sw.on{border:2.5px solid var(--white);transform:scale(1.15)}
.sd-cpick{width:20px;height:20px;border-radius:50%;border:1.5px dashed rgba(255,255,255,.3);cursor:pointer;background:none;padding:0}
.sd-block-row{display:grid;grid-template-columns:repeat(4,1fr);gap:4px}
.sd-block-thumb{aspect-ratio:1;border-radius:5px;border:1.5px solid var(--b);background:var(--n3);display:flex;flex-direction:column;align-items:center;justify-content:center;cursor:pointer;position:relative;overflow:hidden;gap:2px;padding:3px}
.sd-block-thumb:hover{border-color:var(--teal)}
.sd-block-thumb.on{border:2px solid var(--gold);background:var(--golda)}
.sd-block-thumb.img-on{border:2px solid var(--teal)}
.sd-block-rm{position:absolute;top:2px;right:2px;width:13px;height:13px;background:rgba(239,68,68,.85);border:none;border-radius:50%;color:#fff;font-size:7px;cursor:pointer;display:flex;align-items:center;justify-content:center}
.sd-block-lbl{font-size:7.5px;color:var(--muted);text-align:center;line-height:1.1;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.sd-edit-panel{padding:10px;background:rgba(0,115,153,.05);border:1px solid rgba(0,115,153,.18);border-radius:var(--r);display:flex;flex-direction:column;gap:8px}
.sd-edit-panel.teal{background:rgba(0,180,216,.06);border-color:rgba(0,180,216,.17)}
.sd-ep-title{font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.7px}
.sd-ep-title.gold{color:var(--gold)}
.sd-ep-title.teal{color:var(--teal)}
.sd-drop{border:2px dashed var(--b2);border-radius:var(--r);padding:13px;display:flex;flex-direction:column;align-items:center;gap:5px;cursor:pointer;text-align:center}
.sd-drop:hover{border-color:var(--gold);background:rgba(0,115,153,.05)}
.sd-btn{display:inline-flex;align-items:center;gap:5px;padding:8px 16px;border-radius:var(--r);font-family:var(--ffb);font-size:11px;font-weight:600;cursor:pointer;border:none;transition:all var(--tr);letter-spacing:.3px;text-transform:uppercase}
.sd-btn-gold{background:linear-gradient(135deg,var(--gold),var(--gold2));color:#fff;box-shadow:0 4px 14px rgba(0,115,153,.28)}
.sd-btn-emerald{background:linear-gradient(135deg,var(--emerald),#34d399);color:#fff;box-shadow:0 4px 14px rgba(52,199,89,.25)}
.sd-btn-teal{background:linear-gradient(135deg,var(--teal),var(--teal2));color:#fff}
.sd-btn-sec{background:transparent;color:var(--white);border:1px solid var(--b2)}
.sd-btn-sec:hover{background:var(--b)}
.sd-btn-ghost{background:transparent;color:var(--muted);border:1px solid var(--b)}
.sd-btn-ghost:hover{color:var(--white)}
.sd-btn:disabled{opacity:.4;cursor:not-allowed;pointer-events:none}
.sd-output{background:var(--n2);border:1px solid var(--b2);border-radius:var(--rL);overflow:hidden}
.sd-json-pre{padding:20px;font-family:var(--ffm);font-size:10px;color:#0369a1;background:var(--n0);overflow-x:auto;white-space:pre;line-height:1.7;max-height:500px;overflow-y:auto}
.sd-json-pre .jk{color:#9333ea}
.sd-json-pre .jv{color:#16a34a}
.sd-json-pre .js{color:#ca8a04}
.sd-json-pre .jn{color:#0369a1}
.sd-copy-ok{color:var(--ok);font-size:10px;font-weight:600}
.sd-warn{padding:8px 12px;background:rgba(0,115,153,.07);border:1px solid rgba(0,115,153,.2);border-radius:8px;font-size:10.5px;color:var(--gold2);line-height:1.5}
.sd-info{padding:8px 12px;background:rgba(0,180,216,.07);border:1px solid rgba(0,180,216,.2);border-radius:8px;font-size:10.5px;color:var(--teal2);line-height:1.5}
.sd-ok{padding:8px 12px;background:rgba(52,199,89,.07);border:1px solid rgba(52,199,89,.2);border-radius:8px;font-size:10.5px;color:var(--emerald);line-height:1.5}
.sd-stats{display:flex;gap:12px;flex-wrap:wrap}
.sd-stat{background:var(--n3);border:1px solid var(--b);border-radius:var(--r);padding:10px 16px;display:flex;flex-direction:column;gap:3px;flex:1;min-width:100px}
.sd-stat-val{font-family:var(--ffm);font-size:22px;font-weight:700;color:var(--gold)}
.sd-stat-lbl{font-size:9.5px;color:var(--muted);text-transform:uppercase;letter-spacing:.8px}
.sd-progress-wrap{background:var(--n3);border-radius:20px;height:5px;overflow:hidden;margin-top:4px}
.sd-progress-fill{height:100%;border-radius:20px;background:linear-gradient(90deg,var(--teal),var(--emerald));transition:width .4s ease}
.sd-qbtn:disabled {
  background: var(--n4);
  color: var(--muted2);
  border-color: var(--b);
}
@media(max-width:900px){
  .sd-studio{grid-template-columns:1fr}
  .sd-studio-left{border-right:none;border-bottom:1px solid var(--b)}
  .sd-slot-grid{grid-template-columns:repeat(2,1fr)}
  .sd-main{padding:16px}
}
`;

/* ══════════════════════════════════════════════════════
   COMPOSANT PRINCIPAL — SELLER DASHBOARD
══════════════════════════════════════════════════════ */
export default function SellerDashboard(props) {
  const {
    designs, setDesigns, ImagesProd, slots, setSlots,
    productID,
    authToken,
    infoSource
  } = props;
  __setElakayInfoSource(infoSource);

  const [step, setStep] = useState(0);
  const [images, setImages] = useState("");
  const [templateMeta, setTemplateMeta] = useState({
    label: __elakayText("t011", "My Template"),
    style: "Street Art",
    detail: "Moderate"
  });
  const [output, setOutput] = useState(null);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [activeSlotId, setActiveSlotId] = useState(null);
  const [currentDesigns, setCurrentDesigns] = useState([]);

    /* 🆕 États pour la liste des designs */
  const [previewDesign, setPreviewDesign] = useState(null);  // Design en mode preview
  const [loadedDesignId, setLoadedDesignId] = useState(null); // ID du design chargé pour édition

  /* Hook de la liste */
  const designsList = useDesignsList({ productID, authToken });

  
  /* ══════════════════════════════════════════════════════
     buildCurrentOutput — construit l'output à partir de l'état courant
     Fonctionne dès l'étape 2 pour permettre l'auto-save
  ══════════════════════════════════════════════════════ */
  const buildCurrentOutput = useCallback(() => {
    if (!slots || slots.length === 0) return null;

    return {
      id: `g_${Date.now()}`,
      label:  templateMeta.label  || "Untitled",
      style:  templateMeta.style  || "Street Art",
      detail: templateMeta.detail || "Moderate",
      slots: slots.map((slot, i) => {
        const d = currentDesigns[i] || makeSlotDesign();
        return {
          id:    slot.id,
          label: slot.label,
          url:   slot.localUrl || slot.url || "",
          slotState: {
            texts: d.texts.map(tb => ({ ...tb })),
            layers: d.layers.map(l => ({
              _id:      l._id || undefined,
              urlImg:   l.src || l.url || l.urlImg || "",
              file:     l.file,
              size:     l.size,
              rotation: l.rotation,
              opacity:  l.opacity,
              pos:      { ...l.pos }
            })),
            instructions: d.instructions
          }
        };
      })
    };
  }, [slots, currentDesigns, templateMeta]);


  /* ── Hook de sauvegarde (avec designId initial) ── */
  const save = useDesignSave({
    productID,
    authToken,
    buildOutput: buildCurrentOutput,
    autoSaveEnabled: step >= 2,
    autoSaveInterval: 30000,
    initialDesignId: loadedDesignId  // 🆕 Permet la mise à jour d'un design existant
  });

    /* ══════════════════════════════════════════════════════
     🆕 Charge un design existant pour édition
  ══════════════════════════════════════════════════════ */
  const handleLoadDesign = async (design) => {
    /* On peut soit utiliser le design directement, soit le re-fetcher */
    const fullDesign = await designsList.fetchDesignById(design._id);
    if (!fullDesign) return;

    const parsed = parseLoadedDesign(fullDesign);
    if (!parsed) return;

    /* Mise à jour des états avec les données chargées */
    setSlots(parsed.slots);
    setTemplateMeta(parsed.templateMeta);
    setCurrentDesigns(parsed.designs);
    setLoadedDesignId(parsed.designId);  // ID pour les futures sauvegardes

    /* Notifie le hook save de l'ID du design existant */
    if (save.setDesignId) {
      save.setDesignId(parsed.designId);
      save.setSavedStatus(parsed.status);
    }

    /* Va directement à l'étape 2 (studio) */
    setStep(2);
  };

  /* ══════════════════════════════════════════════════════
     🆕 Handler : Aperçu d'un design
  ══════════════════════════════════════════════════════ */
  const handlePreviewDesign = (design) => {
    setPreviewDesign(design);
  };

  /* ══════════════════════════════════════════════════════
     🆕 Handler : Édition depuis le modal preview
  ══════════════════════════════════════════════════════ */
  const handleEditFromPreview = () => {
    if (!previewDesign) return;
    const designToEdit = previewDesign;
    setPreviewDesign(null);
    handleLoadDesign(designToEdit);
  };

  /* ══════════════════════════════════════════════════════
     🆕 Handler : Création d'un nouveau template (depuis l'étape 0)
  ══════════════════════════════════════════════════════ */
  const handleCreateNew = () => {
    setSlots([{ id: `s${Date.now()}`, label: __elakayText("t026", "Front"), url: "", localUrl: "" }]);
    setTemplateMeta({ label: __elakayText("t011", "My Template"), style: "Street Art", detail: "Moderate" });
    setOutput(null);
    setCurrentDesigns([]);
    setLoadedDesignId(null);  // Reset l'ID pour créer un NEW design
    setStep(1);
  };

  /* ── Handler étape 2 → étape 3 ── */
  const handlePublish = (json) => {
    setOutput(json);
    setStep(3);
  };

  /* ── Handler nouveau template ── */
  const handleNewTemplate = () => {
    setSlots([{ id: `s${Date.now()}`, label: __elakayText("t026", "Front"), url: "", localUrl: "" }]);
    setTemplateMeta({ label: __elakayText("t011", "My Template"), style: "Street Art", detail: "Moderate" });
    handleCreateNew();
    setOutput(null);
    setStep(1);
  };
const handleBackToList = () => {
    setStep(0);
    setLoadedDesignId(null);
    designsList.fetchDesigns();  // Recharge la liste
  };


  /* ── Composant ImageGallery (utilisé dans ImagePickerModal) ── */
  const ImageGallery = () => (
    <div className="image-gallery-section">
      <div className="section-header">
        <h4 className="section-title">{__elakayText("t001", "All Image Items")}</h4>
      </div>
      <div className="image-grid">
        {ImagesProd?.galeries?.map((nm, i) => (
          <div key={i}
            className={`image-grid-item ${images === nm.urlImg ? 'selected' : ''}`}
            onClick={() => setImages(nm.urlImg)}>
            <ShowimagesLoading src={nm.urlImg} alt={nm._id} />
          </div>
        ))}
      </div>
    </div>
  );

  /* 🆕 Steps mis à jour avec étape 0 */
  const STEPS = [
    { num: 0, label: __elakayText("t006", "My Designs") },
    { num: 1, label: __elakayText("t012", "Product Faces") },
    { num: 2, label: __elakayText("t013", "Design Studio") },
    { num: 3, label: __elakayText("t027", "Publish") }
  ];

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <div className="sd-root">
        {/* Top bar */}
         <div className="sd-topbar">
          <div className="sd-brand">
            <span className="sd-logo">ELAKAY</span>
            <span className="sd-logo-tag">{__elakayText("t002", "Seller Studio")}</span>
          </div>
          <div className="sd-steps">
            {STEPS.map(s => (
              <button key={s.num} type="button"
                className={`sd-step${step === s.num ? " sd-step--active" : step > s.num ? " sd-step--done" : ""}`}
                onClick={() => {
                  /* On peut toujours retourner à la liste */
                  if (s.num === 0) { handleBackToList(); return; }
                  if (s.num < step || (s.num === 2 && step === 3)) setStep(s.num);
                }}>
                <span className="sd-step-num">{step > s.num ? "✓" : s.num}</span>
                {s.label}
              </button>
            ))}
          </div>
          <div className="sd-topbar-right">
            {save.busy && <span style={{fontSize:10,color:"var(--gold)"}}>⏳ {save.busyMode}</span>}
            {save.savedStatus === "published" && !save.busy && <span style={{fontSize:10,color:"var(--ok)"}}>{__elakayText("t014", "✅ Published")}</span>}
            {save.savedStatus === "draft" && !save.busy && <span style={{fontSize:10,color:"var(--teal)"}}>{__elakayText("t015", "💾 Draft")}</span>}
            <span style={{fontSize:10,color:"var(--muted)"}}>{__elakayText("t005", "Seller Dashboard")}</span>
          </div>
        </div>

        <div className="sd-main">

       {/* ═══ ÉTAPE 0 — LISTE DES DESIGNS ═══ */}
          {step === 0 && (
            <>
              <div className="sd-sec-head">
                <div className="sd-sec-title">{__elakayText("t006", "My Designs")}</div>
                <div className="sd-sec-sub">{__elakayText("t016", "Manage your saved designs. Click any design to preview, edit, or delete it.")}</div>
              </div>
              <DesignsList
                productID={productID}
                authToken={authToken}
                onCreateNew={handleCreateNew}
                onLoadDesign={handleLoadDesign}
                onPreviewDesign={handlePreviewDesign}
                onEditFace
              />

              {/* Modal preview */}
              {previewDesign && (
                <DesignPreviewModal
                  design={previewDesign}
                  onClose={() => setPreviewDesign(null)}
                  // onEdit={handleEditFromPreview}
                />
              )}
            </>
          )}

               {/* ═══ Barres de statut globales (étapes 2 et 3) ═══ */}
          {step >= 2 && (
            <div style={{marginBottom:16}}>
              <SaveStatusBar
                designId={save.designId}
                savedStatus={save.savedStatus}
                savedAt={save.savedAt}
                busy={save.busy}
                busyMode={save.busyMode}
                error={save.error}
                lastAutoSave={save.lastAutoSave}
                productID={productID}
                onSaveDraft={save.saveDraft}
                onPublish={save.publish}
                onClearError={save.clearError}
                compact={step === 2}
              />
            </div>
          )}

         {/* ═══ Étape 1 ═══ */}
          {step === 1 && (
            <>
              <div className="sd-sec-head">
                <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",marginBottom:8}}>
                  <button type="button" className="sd-btn sd-btn-sec"
                    style={{padding:"5px 12px",fontSize:10}}
                    onClick={handleBackToList}>{__elakayText("t017", "← Back to list")}</button>
                </div>
                <div className="sd-sec-title">{__elakayText("t018", "Step 1 — Product Faces")}</div>
                <div className="sd-sec-sub">{__elakayText("t019", "Configure your product faces (max 8). Each face will get its own independent graffiti design.")}</div>
              </div>
              <ImagePickerModal
                open={pickerOpen}
                onClose={() => setPickerOpen(false)}
                slots={slots}
                setSlots={setSlots}
                ImageGallery={ImageGallery}
                images={images}
                slotId={activeSlotId}
              />
              <SlotManager
                setPickerOpen={setPickerOpen}
                setActiveSlotId={setActiveSlotId}
                slots={slots}
                onSlotsChange={setSlots}
                onNext={() => setStep(2)}
              />
            </>
          )}

               {/* ═══ Étape 2 ═══ */}
          {step === 2 && (
            <>
              <div className="sd-sec-head">
                <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",marginBottom:8}}>
                  <button type="button" className="sd-btn sd-btn-sec"
                    style={{padding:"5px 12px",fontSize:10}}
                    onClick={handleBackToList}>{__elakayText("t017", "← Back to list")}</button>
                  {loadedDesignId && (
                    <span style={{
                      padding:"3px 10px",
                      background:"rgba(0,180,216,.1)",
                      border:"1px solid rgba(0,180,216,.3)",
                      borderRadius:12,
                      fontSize:10,color:"var(--teal)",fontWeight:600
                    }}>{__elakayText("t020", "✏️ Editing existing design")}</span>
                  )}
                </div>
                <div className="sd-sec-title">{__elakayText("t021", "Step 2 — Design Studio")}</div>
                <div className="sd-sec-sub">{__elakayText("t022", "Create your graffiti design face by face. Auto-save every 30 seconds.")}</div>
              </div>
              <DesignStudio
                infoSource={infoSource}
                slots={slots}
                 setSlots={setSlots}        // 🆕 OBLIGATOIRE pour avoir les boutons
                setPickerOpen={setPickerOpen}
                setActiveSlotId={setActiveSlotId}
                onBack={() => setStep(1)}
                onPublish={handlePublish}
                templateMeta={templateMeta}
                onMetaChange={setTemplateMeta}
                onDesignsChange={setCurrentDesigns}
                initialDesigns={currentDesigns.length > 0 ? currentDesigns : null}
                open={pickerOpen}
                ImageGallery={ImageGallery}
                images={images}
                slotId={activeSlotId}
              />
            </>
          )}

        
          {/* ═══ Étape 3 ═══ */}
          {step === 3 && output && (() => {
            const draftPreview   = buildSavePayload(output, productID, "draft");
            const publishPreview = buildSavePayload(output, productID, "published");

            return (
              <>
                <div className="sd-sec-head">
                  <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",marginBottom:8}}>
                    <button type="button" className="sd-btn sd-btn-sec"
                      style={{padding:"5px 12px",fontSize:10}}
                      onClick={handleBackToList}>{__elakayText("t017", "← Back to list")}</button>
                  </div>
                  <div className="sd-sec-title">{__elakayText("t023", "Step 3 — Save & Publish")}</div>
                  <div className="sd-sec-sub">{__elakayText("t024", "Save your design as a draft or publish it to make it available to clients.")}</div>
                </div>

                {!publishPreview.stats.valid && (
                  <div style={{
                    padding:"10px 14px",
                    background:"rgba(0,115,153,.08)",
                    border:"1px solid rgba(0,115,153,.25)",
                    borderRadius:"var(--r)",marginBottom:14,
                    fontSize:11,color:"var(--gold2)",
                    display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"
                  }}>
                    <span style={{fontSize:16}}>⚠️</span>
                    <div style={{flex:1}}>
                      <strong>{__elakayText("t010", "Cannot publish:")}</strong> {publishPreview.stats.error}
                      <div style={{fontSize:10,opacity:0.8,marginTop:2}}>{__elakayText("t025", "You can still save as draft.")}</div>
                    </div>
                  </div>
                )}

                <OutputView
                  output={output}
                  payload={draftPreview.payload}
                  publishPayload={publishPreview.payload}
                  canPublish={publishPreview.stats.valid}
                  onNewTemplate={handleNewTemplate}
                  onEditBack={() => setStep(2)}
                  productID={productID}
                  authToken={authToken}
                  save={save}
                />
              </>
            );
          })()}
        </div>
      </div>
    </>
  );
}
